import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { AuthLayout } from '@/components/layout';
import { GuestOnly, RequireAuth } from '../common/guards';
import { SuspenseWrapper } from '@/routes/common/SuspenseWrapper';

const Login = lazy(() => import('@/pages/auth/Login.tsx'));
const ForgotPassword = lazy(() => import('@/pages/auth/ForgotPassword'));
const ResetPassword = lazy(() => import('@/pages/auth/ResetPassword'));
const RoleSelectionPage = lazy(() => import('@/pages/auth/RoleSelectionPage.tsx'));

export const authRoutes: RouteObject = {
  path: '/',
  element: <AuthLayout />,
  children: [
    {
      path: 'login',
      element: (
        <GuestOnly>
          <SuspenseWrapper>
            <Login />
          </SuspenseWrapper>
        </GuestOnly>
      ),
    },
    {
      path: 'forgot-password',
      element: (
        <GuestOnly>
          <SuspenseWrapper>
            <ForgotPassword />
          </SuspenseWrapper>
        </GuestOnly>
      ),
    },
    {
      path: 'reset-password',
      element: (
        <GuestOnly>
          <SuspenseWrapper>
            <ResetPassword />
          </SuspenseWrapper>
        </GuestOnly>
      ),
    },
    {
      path: 'select-role',
      element: (
        <RequireAuth>
          <SuspenseWrapper>
            <RoleSelectionPage />
          </SuspenseWrapper>
        </RequireAuth>
      ),
    },
  ],
};
